import React from "react";
import styles from "./footer.module.css";
import dablerlogo from "../../../CommonImages/dabler5.png";
import { MapPin, Mail, Facebook, Linkedin } from "lucide-react";
import { socialLinks } from "../../../../App";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      {/* Top Row */}
      <div className={styles.topRow}>
        {/* Logo */}
        <div className={styles.logoSection}>
          <img src={dablerlogo} alt="Dabler Logo" className={styles.logo} />
        </div>

        {/* Info Columns */}
        <div className={styles.columnsWrapper}>
          {/* Address */}
          <div className={styles.column}>
            <h4 className={styles.columnTitle}>
              Address
            </h4>
            <p><MapPin size={16} style={{ marginRight: "8px", verticalAlign : 'middle' }} />Location</p>
            <p>128 City Road, London,</p>
            <p>United Kingdom, EC1V 2NX</p>
            <p style={{marginTop : "1rem"}}><Mail size={16} style={{ marginRight: "8px",  verticalAlign : 'middle' }} />Email</p>
            <p>dabler@dabler.co.uk</p>
          </div>

          {/* Products */}
          <div className={styles.column}>
            <h4 className={styles.columnTitle}>Products</h4>
            <a href="/datakob">DataKob</a>
            <a href="/snippetflow">SnippetFlow</a>
            <a href="/acuber">Acuber AI</a>
          </div>

          {/* Social */}
          <div className={styles.column}>
            <h4 className={styles.columnTitle}>Follow Us</h4>
            <div className={styles.socialIcons}>
              <a href={socialLinks.linkedIn} target="_blank" rel="noreferrer">
                <Linkedin className={styles.socialIcon} />
              </a>
              <a href={socialLinks.fb} target="_blank" rel="noreferrer">
                <Facebook className={styles.socialIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className={styles.bottomRow}>
        <p>© Copyright DABLER - All Rights Reserved</p>
      </div>
    </footer>
  );
}
